import React, { useState } from "react";
import { Grid, Box, Typography } from "@mui/material";
import { DatePicker } from "antd";
import {IAssignment} from "../index"
interface IAvalibility{
    assignData:IAssignment;
    setAssignData:React.Dispatch<React.SetStateAction<IAssignment>>;
}
const Availability: React.FC<IAvalibility> = ({assignData,setAssignData}:IAvalibility) => {


    return (
        <Box sx={{ p: 2, background: "#F8FAFD", borderRadius: "8px" }}>
            <Grid container spacing={2}>

                {/* Available From */}
                <Grid item xs={12} textAlign={"start"}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 400, mb: 1 }}>
                        Available From (Time & Date) *
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6} sx={{ width: "30%" }}>
                    <DatePicker
                        showTime
                        format="YYYY-MM-DD h:mm A"
                        name="allowsubmissionsfromdate"
                        style={{ width: "100%", height: "3rem" }}
                        value={assignData.allowsubmissionsfromdate}
                        onChange={(date)=>{
                            setAssignData({...assignData,allowsubmissionsfromdate:date});
                        }}
                    />
                </Grid>

                {/* Available Till */}
                <Grid item xs={12} textAlign={"start"}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 400, mb: 1 }}>
                        Available Till (Time & Date) *
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6} sx={{ width: "30%" }}>
                    <DatePicker
                        showTime
                        format="YYYY-MM-DD h:mm A"
                        style={{ width: "100%", height: "3rem" }}
                        name="duedate"
                        value={assignData.duedate}
                        onChange={(date)=>{
                            setAssignData({...assignData,duedate:date});
                        }}
                    />
                </Grid>

            </Grid>
        </Box>
    );
};

export default Availability;
